'use strict';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ModalComponent } from './component';
import { ModalService } from './service';
import { LKIcon } from '../icon/module';
import { ModalFooterComponent } from './modalfooter/component';
import { LKContextBubble } from "../contextbubble/module";
import { ModalConfirmComponent } from "./confirm/component";

@NgModule({
  imports     : [
    BrowserModule,
    LKIcon,
    LKContextBubble
  ],
  declarations: [ModalComponent, ModalFooterComponent, ModalConfirmComponent],
  exports     : [ModalComponent, ModalFooterComponent],
  providers   : [ModalService],
  entryComponents: [ModalConfirmComponent]
})
export class LKModal {
}
